module.exports = __webpack_public_path__ + "img/phone_plne_pozadi.e37a5309.svg";